<template v-cloak>
  <li class="accordion-item">
    <h3 class="accordion-item__heading">
      <button
        :id="`accordion${accordionId}-trigger`"
        class="accordion-item__trigger"
        :aria-controls="`accordion${accordionId}-section`"
        :aria-expanded="show"
        @click="toggleAccordion"
      >
        <span class="accordion-item__trigger-container">
          <span class="accordion-item__heading-item">
            <slot name="heading"></slot>
          </span>
          <span
            :class="[show ? `${iconClass}--open` : '', iconClass]"
          >
          </span>
        </span>
      </button>
    </h3>
    <section
      :id="`accordion${accordionId}-section`"
      class="accordion-item__panel"
      :class="{'accordion-item__panel--open': show}"
      :aria-labelledby="`accordion${accordionId}-trigger`"
    >
      <div class="accordion-item__content-wrapper">
        <div class="accordion-item__transform-wrapper">
          <div class="accordion-item__content-display">
            <slot name="content"></slot>
          </div>
        </div>
      </div>

    </section>
  </li>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  accordionId: {
    type: Number,
    required: true,
    default: 0
  },
  expandItem: {
    type: Boolean,
    default: false
  },
  iconClass: {
    type: String,
    default: 'accordion-item__heading-icon'
  }
});

const show = ref(props.expandItem);

/**
 * Show / hide the accordion panel
 */
const toggleAccordion = () => {
  show.value = !show.value;
}

</script>
